<template>
    <cmpcontatti :linkmappa="'#mappa'"></cmpcontatti>
    <cmpmappa :linkcontatti="'#contatti'"></cmpmappa>
    <cmpfooter :sticktobottom="false"></cmpfooter>
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"

import cmpcontatti from "../components/cmpcontatti.vue"
import cmpmappa from "../components/cmpmappa.vue"
import cmpfooter from "../components/cmpfooter.vue"






export default {
  name: "contatti",
  mixins:[multilangmixin],
  components:{
    cmpcontatti,
    cmpmappa,
    cmpfooter
    
  },
  props:{
      "lang":String
  },

  created(){
    
  },

}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
